import React, { useState, useEffect, useContext } from 'react';
import {
  Container, Box, TextField, Button, Dialog, DialogContent, Typography,
  DialogTitle, Grid, IconButton, FormControlLabel, Checkbox, Tooltip, InputAdornment, Switch
} from '@mui/material';
import { Add, FileUpload } from '@mui/icons-material';
import Swal from 'sweetalert2';
import axios from 'axios';
import RolesTable from '../components/tables/rolemanagementtable';
import * as XLSX from 'xlsx';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { AuthContext } from '..';

export default function DutiesAllotment() {
  const [showerr, setShowerr] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [rolesList, setRolesList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { companyid, permissions, token } = useContext(AuthContext);
  const [editicon, setEditicon] = useState(true);
  const [deleteiocn, setDeleteicon] = useState(true);
  const [formData, setFormData] = useState({
    role_name: '',
    permissions: {
      employees: {},
      bills: {},
      masters: {},
      leads: {},
      clients: {},
      rolemanagement: {},
      services: {},
      followup: {},
      orientation: {}
    },
    self_only: false,
  });

  const permissionsaccess = () => {
    const rolemanagementmodule = permissions.rolemanagement || {};
    setDeleteicon(rolemanagementmodule.delete === true);
    setEditicon(rolemanagementmodule.update === true);
  };

  useEffect(() => {

    fetchRoles();
  }, []);

  useEffect(() => {
    if (permissions && permissions.rolemanagement) {
      permissionsaccess();
    }
  }, [permissions]);

  const fetchRoles = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/roles/getrole`, {
      headers:
      {
        Authorization: `bearer ${token}`
      },
      withCredentials: true
    })
      .then((res) => {
        setRolesList(res.data);
      })
      .catch(err => console.error("Error fetching roles:", err));
  };

  const openAddDialog = () => {
    setFormData({
      role_name: '',
      permissions: {
        employees: {},
        bills: {},
        masters: {},
        leads: {},
        clients: {},
        rolemanagement: {},
        services: {},
        followup: {},
        orientation: {}
      },
      self_only: false,
    });
    setEditingId(null);
    setOpenDialog(true);
  };

  const handleEdit = (index) => {
    const role = rolesList[index];
    setFormData({ ...role });
    setEditingId(index);
    setOpenDialog(true);
  };

  const handleDelete = (roleName) => {
    Swal.fire({
      title: 'Confirm Delete',
      text: `Delete role "${roleName}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#E74C3C',
      confirmButtonText: 'Delete'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${process.env.REACT_APP_API_LINKS}/roles/deleterole/${roleName}`, {
          headers:
          {
            Authorization: `bearer ${token}`
          }, withCredentials: true
        })
          .then(() => {
            Swal.fire('Deleted!', 'Role has been deleted.', 'success');
            fetchRoles();
          })
          .catch(err => Swal.fire('Error', 'Failed to delete role', 'error'));
      }
    });
  };

  const closeDialog = () => {
    setOpenDialog(false);
    setFormData({
      role_name: '',
      permissions: {
        employees: {},
        bills: {},
        masters: {},
        leads: {},
        clients: {},
        rolemanagement: {},
        services: {},
        followup: {},
        orientation: {}
      },
      self_only: false,
    });
    setEditingId(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (showerr) {
      if (formData.role_name.length > 0) {
        setShowerr(false);
      }
    }
  };

  const handleCheckboxChange = (module, permission) => (e) => {
    const checked = e.target.checked;
    setFormData(prev => {
      const updatedPermissions = {
        ...prev.permissions,
        [module]: {
          ...prev.permissions[module],
          [permission]: checked
        }
      };

      if ((permission === 'can_update' || permission === 'can_delete' || permission === 'can_write') && checked) {
        updatedPermissions[module] = {
          ...updatedPermissions[module],
          can_read: true
        };
      }
      if (permission === 'can_read' && !checked) {
        updatedPermissions[module] = {
          ...updatedPermissions[module],
          can_update: false,
          can_delete: false,
          can_write: false
        };
      }

      return {
        ...prev,
        permissions: updatedPermissions
      };
    });
  };

  const handleSelfonlyToggle = (e) => {
    setFormData(prev => ({ ...prev, self_only: e.target.checked }));
  };

  const handleSubmit = () => {
    if (!formData.role_name) {
      return setShowerr(true);
    }

    const apiCall = editingId !== null
      ? axios.put(`${process.env.REACT_APP_API_LINKS}/roles/updaterole`, formData, {
        headers:
        {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      })
      : axios.post(`${process.env.REACT_APP_API_LINKS}/roles/addrole`, { ...formData, companyid }, {
        headers:
        {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      });

    apiCall
      .then(() => {
        Swal.fire('Success', `Role ${editingId !== null ? 'updated' : 'added'} successfully!`, 'success');
        fetchRoles();
        closeDialog();
      })
      .catch(err => {
        const message = err.response?.status === 409
          ? 'Role already exists!'
          : `Failed to ${editingId !== null ? 'update' : 'add'} role`;
        Swal.fire('Error', message, 'error');
      });
  };

  const exportToExcel = () => {
    const exportData = rolesList.filter(role =>
      role.role_name.toLowerCase().includes(searchTerm.toLowerCase())
    ).map(role => ({
      'Role Name': role.role_name,
      'Self Only': role.self_only ? 'Yes' : 'No',
      ...Object.entries(role.permissions).reduce((acc, [module, perms]) => {
        Object.entries(perms).forEach(([perm, val]) => {
          acc[`${module}_${perm}`] = val ? 'Yes' : 'No';
        });
        return acc;
      }, {})
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Roles');
    XLSX.writeFile(workbook, 'roles_export.xlsx');
  };

  const filteredRoles = Array.isArray(rolesList) && rolesList.length > 0
    ? rolesList.filter(role =>
      role.role_name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : [];


  return (
    <Container maxWidth={false} disableGutters sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: 3,
      fontFamily: 'Open Sans',
      bgcolor: '#ffffff',
      minHeight: '100vh',
      boxShadow: { xs: 'none', sm: '0px 0px 5px rgba(187, 222, 241, 0.9)' },
      borderRadius: 2
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row', md: 'row' },
        justifyContent: { md: 'space-between' },
        alignItems: { md: 'center' },
        gap: 2,
        mb: 1,
      }}>
        <TextField
          placeholder="Search roles..."
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ minWidth: 200, width: { sm: 400, md: 500 }, }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'row', sm: 'row', md: 'row' },
          justifyContent: { xs: 'flex-start', sm: 'space-between', md: 'flex-end' },
          alignItems: 'center',
          width: '100%',
          gap: { xs: 1, sm: 2 },
        }}>
          {permissions?.rolemanagement?.create && <Button
            variant="contained"
            startIcon={<Add />}
            onClick={openAddDialog}
            sx={{
              bgcolor: '#0b85c8',
              width: { xs: '100%', sm: 'auto' },
              fontFamily: 'Open Sans',
              borderRadius: 2
            }}
          >
            Add Role
          </Button>}

          <Tooltip title="Export to Excel">
            <IconButton onClick={exportToExcel} sx={{ color: '#0b85c8' }}>
              <FileUpload />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <RolesTable
        rolesList={filteredRoles}
        onEdit={handleEdit}
        onDelete={handleDelete}
        editicon={editicon}
        deleteicon={deleteiocn}
        sx={{ border: '1px solid #e0e0e0' }}
      />

      <Dialog open={openDialog} maxWidth="sm" fullWidth>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f0f9ff',
          px: 2,
        }}>
          <DialogTitle sx={{ color: '#0b85c8', fontWeight: 600, margin: 'auto', mt: 1, fontFamily: 'Open Sans' }}>
            {editingId !== null ? 'Edit Role' : 'Create New Role'}
          </DialogTitle>
          <IconButton onClick={closeDialog}>
            <CloseIcon sx={{ bgcolor: '#0b85c8', borderRadius: 2, mr: 2, color: 'white' }} />
          </IconButton>
        </Box>

        <DialogContent sx={{ bgcolor: '#f8fbff', p: 3 }}>
          <Box sx={{ bgcolor: 'white', p: 3, borderRadius: 2, boxShadow: '0px 0px 10px #ccc' }}>
            <TextField
              fullWidth
              label="Role Name"
              name="role_name"
              value={formData.role_name}
              onChange={handleChange}
              error={showerr}
              helperText={showerr ? "Please fill the Role Name" : null}
              size="small"
              sx={{ mb: 3 }}
            />

            {['employees', 'bills', 'masters', 'leads', 'clients', 'rolemanagement', 'services', 'followup', 'orientation'].map(module => (
              <Box key={module} sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={1} sx={{ fontFamily: 'Open Sans' }}>
                  {module.charAt(0).toUpperCase() + module.slice(1)} Permissions
                </Typography>
                <Grid container spacing={1} sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-evenly' }}>
                  {['read', 'write', 'update', 'delete'].map(action => (
                    <Box item key={`${module}_${action}`}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{ '&.Mui-checked': { color: '#0b85c8' } }}
                            checked={formData.permissions[module]?.[`can_${action}`] || false}
                            onChange={handleCheckboxChange(module, `can_${action}`)}
                          />
                        }
                        label={action.charAt(0).toUpperCase() + action.slice(1)}
                      />
                    </Box>
                  ))}
                </Grid>
              </Box>
            ))}

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'start', ml: -2 }}>
              <FormControlLabel
                label="Self Only"

                sx={{
                  fontFamily: 'Open Sans', fontWeight: 600,
                  '& .MuiFormControlLabel-label': {
                    fontWeight: 600,
                    fontFamily: 'Open Sans'
                  },
                }}
                labelPlacement='start'
                control={
                  <Switch
                    checked={formData.self_only}
                    onChange={handleSelfonlyToggle}
                    sx={{ '&.Mui-checked': { color: '#0b85c8' } }}
                  />
                }

              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{ bgcolor: '#0b85c8', px: 4, borderRadius: 2, fontFamily: 'Open Sans' }}
              >
                {editingId !== null ? 'Update Role' : 'Create Role'}
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
}
